import { c as _c } from "react/compiler-runtime";
import React from "react";
import clsx from "clsx";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { ImageScale } from "@/helpers/image.helpers";
import WaveDropPartContentFullWidthImage from "./WaveDropPartContentFullWidthImage";
function isRenderableMedia(mimeType: string, url: string): boolean {
  return mimeType.includes("image") || mimeType.includes("video") || mimeType.includes("audio") || mimeType === "model/gltf-binary" || mimeType === "model/gltf+json" || mimeType === "text/html" || url.endsWith(".glb") || url.endsWith(".gltf");
}
interface WaveDropPartContentMediasProps {
  readonly activePart: ApiDropPart;
  readonly disableMediaInteraction?: boolean | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly imageScale?: ImageScale | undefined;
  readonly fullWidthMedia?: boolean | undefined;
}
const WaveDropPartContentMedias: React.FC<WaveDropPartContentMediasProps> = t0 => {
  const $ = _c(20);
  const {
    activePart,
    disableMediaInteraction: t1,
    isCompetitionDrop: t2,
    imageScale: t3,
    fullWidthMedia: t4
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  const isCompetitionDrop = t2 === undefined ? false : t2;
  const imageScale = t3 === undefined ? ImageScale.AUTOx450 : t3;
  const fullWidthMedia = t4 === undefined ? false : t4;
  if (!activePart.media.length) {
    return null;
  }
  const hasContentBeforeMedia = Boolean(activePart.content?.trim()) || Boolean(activePart.quoted_drop?.drop_id);
  let topSpacingClassName = "tw-mt-1";
  if (hasContentBeforeMedia) {
    topSpacingClassName = "tw-mt-4";
  } else {
    if (fullWidthMedia) {
      topSpacingClassName = "tw-mt-0";
    }
  }
  let t5;
  if ($[0] !== topSpacingClassName) {
    t5 = clsx(topSpacingClassName, "tw-space-y-3");
    $[0] = topSpacingClassName;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const mediaStackClassName = t5;
  let t6;
  if ($[2] !== fullWidthMedia) {
    t6 = t7 => {
      const {
        useNaturalHeightImage,
        useCompactLink
      } = t7;
      if (useNaturalHeightImage || useCompactLink) {
        return "tw-w-full";
      }
      return clsx("tw-flex tw-h-64 tw-items-center tw-justify-center", fullWidthMedia && "tw-w-full");
    };
    $[2] = fullWidthMedia;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const getMediaContainerClassName = t6;
  let t7;
  if ($[4] !== activePart.media || $[5] !== disableMediaInteraction || $[6] !== fullWidthMedia || $[7] !== getMediaContainerClassName || $[8] !== imageScale || $[9] !== isCompetitionDrop) {
    let t8;
    if ($[11] !== disableMediaInteraction || $[12] !== fullWidthMedia || $[13] !== getMediaContainerClassName || $[14] !== imageScale || $[15] !== isCompetitionDrop) {
      t8 = (media, i) => {
        const useNaturalHeightImage_0 = fullWidthMedia && media.mime_type.includes("image");
        const useCompactLink_0 = !isRenderableMedia(media.mime_type, media.url);
        const mediaContainerClassName = getMediaContainerClassName({
          useNaturalHeightImage: useNaturalHeightImage_0,
          useCompactLink: useCompactLink_0
        });
        let mediaContent;
        if (disableMediaInteraction) {
          mediaContent = <MediaDisplay media_mime_type={media.mime_type} media_url={media.url} disableMediaInteraction={disableMediaInteraction} imageScale={imageScale} />;
        } else {
          if (useNaturalHeightImage_0) {
            mediaContent = <WaveDropPartContentFullWidthImage src={media.url} imageScale={imageScale} />;
          } else {
            mediaContent = <DropListItemContentMedia media_mime_type={media.mime_type} media_url={media.url} isCompetitionDrop={isCompetitionDrop} imageScale={imageScale} />;
          }
        }
        return <div key={`part-${i}-media-${media.url}`} className={mediaContainerClassName}>{mediaContent}</div>;
      };
      $[11] = disableMediaInteraction;
      $[12] = fullWidthMedia;
      $[13] = getMediaContainerClassName;
      $[14] = imageScale;
      $[15] = isCompetitionDrop;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = activePart.media.map(t8);
    $[4] = activePart.media;
    $[5] = disableMediaInteraction;
    $[6] = fullWidthMedia;
    $[7] = getMediaContainerClassName;
    $[8] = imageScale;
    $[9] = isCompetitionDrop;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[17] !== mediaStackClassName || $[18] !== t7) {
    t8 = <div className={mediaStackClassName}>{t7}</div>;
    $[17] = mediaStackClassName;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default WaveDropPartContentMedias;